import React from 'react';

import { ReactComponent as BoxIcon } from '../../../icons/box.svg';

import './empty-page.scss';

export const EmptyPage = () => {
  return (
    <div className="empty-page">
      <div>
        <BoxIcon />
        <span>This feature is coming soon!</span>
      </div>
    </div>
  );
};
